import type { SubscriptionStatusType } from '@subscriptions/domain/types';
import { SubscriptionStatuses } from '@subscriptions/domain/types';

/**
 * Validated subscription status value object.
 * The empty string represents an absent/unknown status produced by soft-validation reconstruction.
 */
export type SubscriptionStatus = Readonly<SubscriptionStatusType | ''>;

const validStatuses = Object.values(SubscriptionStatuses) as string[];

/**
 * Creates a validated SubscriptionStatus value object.
 *
 * @param raw - Raw status string
 * @returns Validated SubscriptionStatus
 * @throws Error if status is not a valid value
 */
export const createSubscriptionStatus = (raw: string): SubscriptionStatus => {
  if (!validStatuses.includes(raw)) {
    throw new Error(`Invalid subscription status: ${raw}. Must be one of: ${validStatuses.join(', ')}`);
  }
  return raw as SubscriptionStatus;
};
